import _ from 'lodash';
import React, { PureComponent } from 'react';

import { Form } from 'semantic-ui-react';

export class ResettableSelect extends PureComponent {
  state = { value: null, isOpen: false }
  onOpen = () => { this.setState({isOpen: true}) }
  onChange = (evt, { value }) => {
    const { isOpen } = this.state
    const { multiple, resetOnValue, selectOnNavigation } = this.props
    if(multiple && _.isArray(value) && value.length > 1) {
      if(resetOnValue && value.indexOf(resetOnValue) > 0)  {
        value = [resetOnValue]
      } else {
        value = _.without(value, resetOnValue)
      }
    }
    if(selectOnNavigation !== false || !isOpen) {
      if (!isOpen) this.setState({value: value})
      if(_.isFunction(this.props.onChangeState)) {
        this.props.onChangeState({value: value})
      } else if(_.isFunction(this.props.onChange)) {
        this.props.onChange({value: value})
      }
    } else {
      this.setState({value: value})
    }
  }

  onClose = () => {
    this.setState({isOpen: false})
    if(_.isFunction(this.props.onChangeState)) {
      this.props.onChangeState(this.state)
    } else if(_.isFunction(this.props.onChange)) {
      this.props.onChange(this.state)
    }
  }

  render () {
    const {
      value:valueProp, multiple, resetOnValue,
      onChangeState, ...remainingOpts
    } = this.props

    if (this.props.selectOnNavigation !== false)
      return (
        <Form.Select
          {...remainingOpts}
          multiple={multiple}
          value={this.state.value || valueProp || (multiple ? [] : null)}
          onChange={this.onChange} onOpen={this.onOpen} />
      )

    return (
      <Form.Select
        {...remainingOpts}
        multiple={multiple}
        value={this.state.value || valueProp || (multiple ? [] : null)}
        onChange={this.onChange} onOpen={this.onOpen} onClose={this.onClose} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ResettableSelect.jsx